import React from 'react';

export default ({ className, onClick }) => (
  <span className={className} onClick={onClick}>
    <svg x="0px" y="0px" viewBox="0 0 82 82">
      <path d="M8.72,81.36c-1.54,0-3.04-0.81-3.85-2.25c-1.19-2.12-0.43-4.81,1.69-6l57.7-32.33L7.35,8.89
        c-2.12-1.19-2.88-3.88-1.69-6c1.19-2.12,3.88-2.88,6-1.69l63.78,35.73c1.39,0.78,2.25,2.25,2.25,3.85c0,1.6-0.86,3.07-2.25,3.85
        L10.87,80.8C10.19,81.18,9.45,81.36,8.72,81.36z"/>
    </svg>
  </span>
);
